'use strict';

/**
 * Controller definition for LocationModule
 *
 * @category   Cantroller
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.de)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Controller = require('base/Colido.Controller');
var ListLayout = require('./views/layout/list');
var DetailLayout = require('./views/layout/detail');
var RestrictionModalView = require('modules/base/views/layout/restriction-storages-modal');
var ObjectDetailListLayout = require('./views/layout/object-detail-list');
var UndefinedStorageListLayout = require('./views/layout/undefined-storage-list');
var SettingsObjectListModel = require('../../models/settings-object-list');

var ParameterizedCollection = require('base/Colido.ParameterizedCollection');

var StorageController = Controller.extend({
    routes: {
        'catalogs/:catalogId/storages(/filter/*filter)(/sort/:sort)': 'actionOverview',
        'catalogs/:catalogId/storages(/filter/*filter)(/sort/:sort)/show/:id': 'actionUndefinedStorage',
        'catalogs/:catalogId/storages/:id(/filter/*filter)(/sort/:sort)/show/:id': 'actionDetailObject',
        'catalogs/:catalogId/storages/:id(/filter/*filter)(/sort/:sort)(/scrollTo/:sid)': 'actionDetail',
    },

    actionOverview: function(catalogId, filter, sort) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                catalog.storages,
                catalog.sets,
            ], function() {
                var params = new SettingsObjectListModel({
                    catalog: catalog,
                    locationModel: true,
                    activeModel: null,
                    filter: filter,
                    sort: sort,
                });

                var region = App.rootView.mainRegion.currentView.contentRegion;

                if (!(region.currentView instanceof ListLayout)) {
                    var locationModule = App.CollectionModule.LocationModule
                    var layout = new ListLayout({
                        model: params,
                        catalog: catalog,
                    });

                    region.show(layout);
                }

                if (!App.user.get('licenseStorages')) {
                    this.showRestrictionModal(catalog);
                }
            }.bind(this))
        });
    },

    actionDetail: function(catalogId, storageId, objectFilter, objectSort, sid) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                catalog.storages,
                catalog.sets,
            ], function() {
                var storageModel = catalog.storages.get(storageId);

                var params = new SettingsObjectListModel({
                    catalog: catalog,
                    locationModel: storageModel,
                    activeModel: null,
                    filter: null,
                    sort: null,
                });

                //@todo needed?
                var filteredObjectsCollection = new ParameterizedCollection(undefined, {
                    params: params,
                    collection: catalog.objects,
                });

                var region = App.rootView.mainRegion.currentView.contentRegion;

                if (!(region.currentView instanceof DetailLayout)
                    || (region.currentView instanceof DetailLayout
                        && region.currentView.getOption('locationId') !== storageModel.id)
                ) {
                    var layout = new DetailLayout({
                        catalog: catalog,
                        locationId: storageModel.id,
                        model: params,
                        collection: filteredObjectsCollection,
                        baseCollection: catalog.objects,
                    });

                    region.show(layout);
                }

                if (!App.user.get('licenseStorages')) {
                    this.showRestrictionModal(catalog);
                }
            }.bind(this));
        }.bind(this));
    },

    actionDetailObject: function(catalogId, storageId, filter, sort, id) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                catalog.storages,
                catalog.sets,
            ], function() {
                App.CollectionModule.controller.objectsList(catalog.objects, ObjectDetailListLayout, {
                    locationModel: catalog.storages.get(storageId),
                    filter: filter,
                    sort: sort,
                    id: id,
                });
            });
        });
    },

    actionUndefinedStorage: function(catalogId, filter, sort, id) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                catalog.storages,
                catalog.sets,
            ], function() {
                App.CollectionModule.controller.objectsList(catalog.objects, UndefinedStorageListLayout, {
                    locationModel: true,
                    filter: filter,
                    sort: sort,
                    id: id,
                }, {
                    collection: catalog.objects.getObjectsWithNoStorageCollection(),
                });
            })
        });
    },

    showRestrictionModal: function(catalog){
        var restrictionModalView = new RestrictionModalView();

        var options = {
            additionalClassName: 'modal-center modal-restriction',
            additionalBgClassName: 'dont-hide-nav light-bg',
            onBeforeClose: function(data) {
                return _.last(App.router.history) != 'catalogs/' + catalog.id + '/storages'; // über this.routes lösen? wie?
            },
        };

        App.addModal(restrictionModalView, options);
    },
});

module.exports = StorageController;